module.exports = __webpack_public_path__ + "media/customizations/sevenhills/logo-8251d442dd2f7d9f2387cece97818a43.png";